@if (statistics !== null) {
  <div class="row justify-content-between">
    <div class="col-lg-8">
    </div>
    <div class="col-lg-4 d-flex justify-content-xl-end flex-column flex-wrap align-items-lg-end pb-1">
      <ng-select [items]="selectableSeasons" bindLabel="Name" bindValue="Id" [(ngModel)]='seasonValue' (change)="onIntervalChange($event)" [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}"></ng-select>
      <span class="justify-content-left">{{'STATISTICS-DASHBOARD.TARGETS.UPDATE-TIME' | translate : {time:this.statistics.ExpiryInSeconds} }}</span>
    </div>
  </div>
}


@if (statistics !== null) {
  <div class="row">
    <div class="col-xl-12">
      <div class="card card-default">
        <div class="card-header">
          <h2>{{'STATISTICS-DASHBOARD.TARGETS.TITLE' | translate}}</h2>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-xl-3">
              @if (turnOverTotalOptions !== null) {
                <apx-chart  [chart]="turnOverTotalOptions.chart"
                  [colors]="turnOverTotalOptions.colors"
                  [labels]="turnOverTotalOptions.labels"
                  [plotOptions]="turnOverTotalOptions.plotOptions"
                  [series]="turnOverTotalOptions.series">
                </apx-chart>
              }
            </div>
            <div class="col-xl-3 card-turnover-total">
              <div>
                <h1 class="amountTotalCardFormat">{{ statistics.TurnOverWeek | currency:'EUR':'symbol':'1.0-0' }}</h1>
                <p class="amountTitleTotalCardFormat">{{'STATISTICS-DASHBOARD.TARGETS.WEEK' | translate}}</p>
              </div>
              <div class="card-turnover-total-line">
                <h1 class="amountTotalCardFormat">{{ statistics.TurnOverMonth | currency:'EUR':'symbol':'1.0-0' }}</h1>
                <p class="amountTitleTotalCardFormat">{{'STATISTICS-DASHBOARD.TARGETS.MONTH' | translate}}</p>
              </div>
              <div class="card-turnover-total-line">
                <h1 class="amountTotalCardFormat">{{ statistics.TurnOverTotal | currency:'EUR':'symbol':'1.0-0' }}</h1>
                <p class="amountTitleTotalCardFormat">{{'STATISTICS-DASHBOARD.TARGETS.TOTAL' | translate}}</p>
              </div>
            </div>
            <div class="col-xl-6">
              @if (turnoverWeekOptions !== null) {
                <apx-chart  [chart]="turnoverWeekOptions.chart"
                  [stroke]="turnoverWeekOptions.stroke"
                  [colors]="turnoverWeekOptions.colors"
                  [plotOptions]="turnoverWeekOptions.plotOptions"
                  [series]="turnoverWeekOptions.series"
                  [labels]="turnoverWeekOptions.labels"
                  [xaxis]="turnoverWeekOptions.xaxis"
                  [markers]="turnoverWeekOptions.markers"
                  [legend]="turnoverWeekOptions.legend"
                  [tooltip]="turnoverWeekOptions.tooltip">
                </apx-chart>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (statistics !== null) {
  <div class="card card-default card-profile">
    <div class="card-footer card-profile-footer">
      <t4-tabs (selected)="onSelectedTabChange($event)">
        <t4-tab tabTitle="{{'STATISTICS-DASHBOARD.TARGETS.ACCOUNTMANAGER' | translate}}" id="A"></t4-tab>
        <t4-tab tabTitle="{{'STATISTICS-DASHBOARD.TARGETS.PASSE-PARTOUT' | translate}}" id="P"></t4-tab>
      </t4-tabs>
    </div>
  </div>
}

@if (statistics !== null) {
  <div class="customer-details">
    @if (selectedTabId === 'A') {
      <h2>{{'STATISTICS-DASHBOARD.TARGETS.REVENUE-PER-ACCOUNTMANAGER' | translate}}</h2>
      <div class="row row-sm" matchHeight="card-body-height">
        @for (item of statistics.TurnOverAccountManagers; track item) {
          <div class="col-4">
            <app-card-turnover [Name]="item.Name" [TurnOverWeek]="item.TurnOverWeek" [TurnOverMonth]="item.TurnOverMonth" [TurnOverTotal]="item.TurnOverTotal" [RealizedTargetPerc]="item.RealizedTargetPerc"></app-card-turnover>
          </div>
        }
      </div>
    }
    @if (selectedTabId === 'P') {
      <h2>{{'STATISTICS-DASHBOARD.TARGETS.REVENUE-PER-PASSE-PARTOUT' | translate}}</h2>
      <div class="row row-sm" matchHeight="card-body-height">
        @for (item of statistics.TurnOverPassePartouts; track item) {
          <div class="col-4">
            <app-card-turnover [Name]="item.Name" [TurnOverWeek]="item.TurnOverWeek" [TurnOverMonth]="item.TurnOverMonth" [TurnOverTotal]="item.TurnOverTotal" [RealizedTargetPerc]="item.RealizedTargetPerc"></app-card-turnover>
          </div>
        }
      </div>
    }
  </div>
}
